import { useAppContext } from 'core/hooks';
import { AnalyticsStructureStore } from 'core/stores/analytics-structure.store';
import useComponentContext from './use-component-context';

const getOrdinal = (day: number) => {
  if (day >= 4 && day <= 20) {
    return 'th';
  }

  const modulus = day % 10;

  switch (modulus) {
    case 1:
      return 'st';

    case 2:
      return 'nd';

    case 3:
      return 'rd';

    default:
      return 'th';
  }
}

const usePaymentDateWithOrdinal = () => {
  const { recurringPaymentStore } = useAppContext();
  const { amountToPayStore } = useComponentContext();

  // const dueDate = recurringPaymentStore.hasRecurringPayment
  //   ? recurringPaymentStore.recurringPaymentDetails?.dueDate || amountToPayStore.dueDate
  //   : amountToPayStore.dueDate;
  // The dueDate from the recurring customer endpoint is wrong
  const dueDate = amountToPayStore.dueDate;

  const paymentDay = new Date(dueDate).getDate();

  const ordinal = getOrdinal(paymentDay);

  const dateWithOrdinal = `${paymentDay}${ordinal}`;

  AnalyticsStructureStore.updateProperty('dateOrdinal', dateWithOrdinal);

  return dateWithOrdinal;
}

export default usePaymentDateWithOrdinal;